import React from "react";

const SIZE = 120;

const PersonalityCircle = ({
  topLabel,
  bottomLabel,
  topPercent,
  topColor,
  bottomColor
}) => {
  const bottomPercent = 100 - topPercent;
  const isFullTop = topPercent === 100;
  const isFullBottom = topPercent === 0;

  return (

    <div style={{ textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "space-between", height: 210, width: 150 }}>
      {/* Top Label */}
      <div style={{ marginBottom: 6, fontSize: 15, fontWeight: 500 }}>
        {topLabel}-{topPercent}%
      </div>

      {/* Circle */}
      <div
        style={{
          width: SIZE,
          height: SIZE,
          borderRadius: "50%",
          overflow: "hidden",
          position: "relative",
          margin: "auto",
          background: isFullTop
            ? topColor
            : isFullBottom
              ? bottomColor
              : "transparent",
          border: "1px solid #ddd"
        }}
      >
        {/* NORMAL CASE (1–99%) */}
        {!isFullTop && !isFullBottom && (
          <>
            {/* Top area */}
            <div
              style={{
                height: `${topPercent}%`,
                background: topColor
              }}
            />

            {/* Bottom area */}
            <div
              style={{
                height: `${bottomPercent}%`,
                background: bottomColor
              }}
            />

            {/* Divider */}
            <div
              style={{
                position: "absolute",
                top: `${topPercent}%`,
                left: 0,
                width: "100%",
                height: 0,
                background: "#fff"
              }}
            />

            {/* Top % */}
            <span
              style={{
                position: "absolute",
                top: `${topPercent / 2}%`,
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: 12,
                color: "#fff",
                fontWeight: 600
              }}
            >
              {topPercent}%
            </span>

            {/* Bottom % */}
            <span
              style={{
                position: "absolute",
                top: `${topPercent + bottomPercent / 2}%`,
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: 12,
                color: "#fff",
                fontWeight: 600
              }}
            >
              {bottomPercent}%
            </span>
          </>
        )}

        {/* 100% CASE */}
        {isFullTop && (
          <span
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: 12,
              color: "#fff",
              fontWeight: 600
            }}
          >
            100%
          </span>
        )}

        {/* 0% CASE */}
        {isFullBottom && (
          <span
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: 12,
              color: "#fff",
              fontWeight: 600
            }}
          >
            0%
          </span>
        )}
      </div>

      {/* Bottom Label */}
      <div style={{ marginTop: 6, fontSize: 15, fontWeight: 500 }}>
        {bottomLabel}-{bottomPercent}%
      </div>
    </div>
  );
};

export default PersonalityCircle;
